import { render, staticRenderFns } from "./recomendaciones.vue?vue&type=template&id=1c4e22f4&scoped=true&"
import script from "./recomendaciones.vue?vue&type=script&lang=js&"
export * from "./recomendaciones.vue?vue&type=script&lang=js&"
import style0 from "./recomendaciones.vue?vue&type=style&index=0&id=1c4e22f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4e22f4",
  null
  
)

export default component.exports